export const STATIC_VARIANT = 'static'
export const TESTIMONIAL_PATTERN = '/images/testimonial-rating.svg'
